export default {
  SET_USER_SESSIONS: 'setUserSessions',
  NEW_USER_SESSION: 'newUserSession',
  ADD_USER_SESSION: 'addUserSession',
  REMOVE_USER_SESSION: 'removeUserSession',
  UPDATE_USER_SESSION: 'updateUserSession',
}